import React from 'react'
import ResourceCreateForm from '../../forms/ResourceCreateForm'

function ResourceAdminCreate() {
  return (
    <div>
        <ResourceCreateForm/>
    </div>
  )
}

export default ResourceAdminCreate